import { useState, useMemo } from "react";
import { aiApi } from "./services/aiApi";

const BASE = "https://support.gs-group.fr/api";
const h = () => ({ "Content-Type":"application/json", Authorization:"Bearer "+localStorage.getItem("nexo_token") });

const STATUT_C = {ouvert:"#ef4444",open:"#ef4444",en_cours:"#f5a623","in-progress":"#f5a623",resolu:"#22d3a0",resolved:"#22d3a0",ferme:"#8899bb",closed:"#8899bb"};
const STATUT_L = {ouvert:"Ouvert",open:"Ouvert",en_cours:"En cours","in-progress":"En cours",resolu:"Résolu",resolved:"Résolu",ferme:"Fermé",closed:"Fermé"};
const PRIO_C   = {critique:"#ef4444",urgente:"#ef4444",haute:"#f5a623",high:"#f5a623",normale:"#5b6ef8",medium:"#5b6ef8",basse:"#22d3a0",low:"#22d3a0"};
const SOURCE_IC = {telephone:"📞",email:"📧",web:"🌐",application:"📱",manual:"📋"};
const TYPE_SAV = {
  preventif: { lbl:"Préventif", ic:"🔧", color:"#10b981", sub:["Remplacement piles","Maintenance annuelle","Mise à jour firmware","Contrôle général","Nettoyage / Vérification","Autre préventif"] },
  curatif:   { lbl:"Curatif",  ic:"🚨", color:"#ef4444", sub:["Panne matériel","Faux contacts / Câblage","Défaut configuration","Remplacement équipement","Réinitialisation","Intrusion / Alarme déclenchée","Autre curatif"] },
};

function getDateSection(d) {
  if (!d) return "Sans date";
  const dt = new Date(d);
  const today = new Date(); today.setHours(0,0,0,0);
  const diff = Math.floor((new Date(dt.getFullYear(),dt.getMonth(),dt.getDate()) - today) / 86400000);
  if (diff === 0)  return "Aujourd'hui";
  if (diff === -1) return "Hier";
  if (diff >= -7 && diff < 0)  return "Cette semaine";
  if (diff >= -30 && diff < -7) return "Ce mois-ci";
  return "Plus ancien";
}
const SEC_ORDER = ["Aujourd'hui","Hier","Cette semaine","Ce mois-ci","Plus ancien","Sans date"];
const SEC_C = {"Aujourd'hui":"#5b6ef8","Hier":"#f5a623","Cette semaine":"#22d3a0","Ce mois-ci":"#a855f7","Plus ancien":"#8899bb","Sans date":"#8899bb"};

export default function SAVListView({ T, tickets=[], clients=[], techniciens=[], onNew, onUpdated }) {
  const [search, setSearch]     = useState("");
  const [statut, setStatut]     = useState("all");
  const [priorite, setPriorite] = useState("all");
  const [triPar, setTriPar]     = useState("date");
  const [ordre, setOrdre]       = useState("desc");
  const [grouped, setGrouped]   = useState(true);
  const [typeSAV, setTypeSAV]   = useState("all"); // "all" | "preventif" | "curatif"
  const [collapsed, setCollapsed] = useState({});
  const [selTicket, setSelTicket] = useState(null);
  const [saving, setSaving]     = useState(false);
  const [pendingClose, setPendingClose] = useState(null); // {id, newStatut, ticket}
  const [closeEmail, setCloseEmail] = useState("");
  const [closeSendMail, setCloseSendMail] = useState(true);
  const [closeMsg, setCloseMsg] = useState("");
  const [closeSaving, setCloseSaving] = useState(false);
  const [aiSuggLoading, setAiSuggLoading] = useState(false);
  const [aiSuggestions, setAiSuggestions] = useState(null);
  const [aiSuggError, setAiSuggError] = useState(null);

  const genererSuggestionsIA = async () => {
    if (!pendingClose || !closeMsg.trim()) return;
    setAiSuggLoading(true); setAiSuggError(null); setAiSuggestions(null);
    try {
      const suggestions = await aiApi.suggestEmail(closeMsg, `Clôture de ticket SAV — ${pendingClose.ticket?.objet||""}`);
      setAiSuggestions(suggestions);
    } catch (e) {
      setAiSuggError(e.message);
    }
    setAiSuggLoading(false);
  };

  const filtered = useMemo(()=>{
    let list = [...tickets];
    if (search) {
      const s = search.toLowerCase();
      list = list.filter(t=>(t.objet+t.description+t.ville+t.reference).toLowerCase().includes(s));
    }
    if (statut !== "all") {
      list = list.filter(t => t.statut === statut ||
        (statut==="ouvert" && ["ouvert","open"].includes(t.statut)) ||
        (statut==="en_cours" && ["en_cours","in-progress"].includes(t.statut)) ||
        (statut==="resolu" && ["resolu","resolved"].includes(t.statut))
      );
    }
    if (priorite !== "all") list = list.filter(t=>t.priorite===priorite);
    if (typeSAV !== "all") list = list.filter(t=>(t.type_sav||"curatif")===typeSAV);

    list.sort((a,b)=>{
      let va,vb;
      if (triPar==="date") { va=new Date(a.created_at||0).getTime(); vb=new Date(b.created_at||0).getTime(); }
      else if (triPar==="priorite") { const po={critique:0,urgente:0,haute:1,normale:2,basse:3}; va=po[a.priorite]??9; vb=po[b.priorite]??9; }
      else if (triPar==="statut") { const so={ouvert:0,en_cours:1,resolu:2,ferme:3}; va=so[a.statut]??9; vb=so[b.statut]??9; }
      else if (triPar==="ville") { va=(a.ville||"").toLowerCase(); vb=(b.ville||"").toLowerCase(); }
      const cmp = typeof va==="string"?va.localeCompare(vb):va-vb;
      return ordre==="asc"?cmp:-cmp;
    });
    return list;
  },[tickets,search,statut,priorite,triPar,ordre]);

  const groupedData = useMemo(()=>{
    if (!grouped) return null;
    const groups = {};
    filtered.forEach(t=>{
      const sec = getDateSection(t.created_at);
      if (!groups[sec]) groups[sec]=[];
      groups[sec].push(t);
    });
    return SEC_ORDER.filter(s=>groups[s]).map(s=>({label:s,items:groups[s]}));
  },[filtered,grouped]);

  const toggleSection = (l) => setCollapsed(p=>({...p,[l]:!p[l]}));

  const openCloseDialog = (ticket, newStatut) => {
    const email = ticket.client_email || "";
    const lbl = newStatut==="resolu" ? "résolu" : "fermé";
    const ref = ticket.reference?.startsWith("SAV-") ? ticket.reference : "";
    const defaultMsg = `Bonjour${ticket.client_nom ? " "+ticket.client_nom : ""},\n\nNous avons le plaisir de vous informer que votre ticket SAV${ref ? " ("+ref+")" : ""} concernant "${ticket.objet}" a été ${lbl}.\n\nSi vous avez d'autres questions ou si le problème persiste, n'hésitez pas à nous contacter.\n\nCordialement,\nL'équipe GS GROUP\nTél : 03.89.50.70.80 · contact@gs-group.fr`;
    setCloseEmail(email);
    setCloseSendMail(!!email);
    setCloseMsg(defaultMsg);
    setPendingClose({id: ticket.id, newStatut, ticket});
    setAiSuggestions(null);
    setAiSuggError(null);
  };

  const confirmClose = async (forceSendMail) => {
    if (!pendingClose) return;
    const sendEmail = forceSendMail !== undefined ? forceSendMail : closeSendMail;
    setCloseSaving(true);
    const { id, newStatut, ticket } = pendingClose;
    await fetch(`${BASE}/tickets/${id}`,{method:"PATCH",headers:h(),body:JSON.stringify({statut:newStatut})});
    if (sendEmail && closeEmail) {
      const lbl = newStatut==="resolu" ? "résolu" : "fermé";
      const ref = ticket.reference?.startsWith("SAV-") ? " ("+ticket.reference+")" : "";
      await fetch(`${BASE}/tickets/${id}/send-closure-email`,{
        method:"POST", headers:h(),
        body:JSON.stringify({
          to: closeEmail,
          subject: `Votre ticket SAV${ref} est ${lbl} — GS GROUP`,
          body: closeMsg
        })
      });
    }
    setCloseSaving(false);
    setPendingClose(null);
    onUpdated&&onUpdated();
    if (selTicket?.id===id) setSelTicket(t=>({...t, statut:newStatut}));
  };

  const changeStatut = async (id, newStatut) => {
    const ticket = tickets.find(t=>t.id===id) || selTicket;
    if (["resolu","ferme"].includes(newStatut) && ticket) {
      openCloseDialog(ticket, newStatut);
      return;
    }
    setSaving(true);
    await fetch(`${BASE}/tickets/${id}`,{method:"PATCH",headers:h(),body:JSON.stringify({statut:newStatut})});
    setSaving(false);
    onUpdated&&onUpdated();
    if (selTicket?.id===id) setSelTicket(t=>({...t,statut:newStatut}));
  };

  const counts = {
    all:tickets.length,
    ouvert:tickets.filter(t=>["ouvert","open"].includes(t.statut)).length,
    en_cours:tickets.filter(t=>["en_cours","in-progress"].includes(t.statut)).length,
    resolu:tickets.filter(t=>["resolu","resolved"].includes(t.statut)).length,
  };

  const TicketCard = ({t}) => {
    const sc = STATUT_C[t.statut]||"#8899bb";
    const pc = PRIO_C[t.priorite]||T.muted;
    // Afficher référence propre (pas UUID)
    const refDisplay = t.reference && !t.reference.includes('-') ? t.reference :
                       t.reference?.startsWith('SAV-202') ? t.reference : null;
    return (
      <div onClick={()=>setSelTicket(t)}
        style={{background:T.card,border:`1.5px solid ${T.border}`,borderRadius:14,padding:"13px 16px",display:"flex",gap:12,cursor:"pointer",transition:"all 0.12s"}}
        onMouseEnter={e=>{e.currentTarget.style.borderColor=sc;e.currentTarget.style.transform="translateX(3px)";}}
        onMouseLeave={e=>{e.currentTarget.style.borderColor=T.border;e.currentTarget.style.transform="none";}}>
        <div style={{width:4,minHeight:44,borderRadius:2,background:sc,flexShrink:0,alignSelf:"stretch"}}/>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:5,flexWrap:"wrap"}}>
            {refDisplay&&<span style={{fontSize:10,color:T.muted,fontFamily:"monospace",background:T.bg,padding:"1px 6px",borderRadius:16,border:`1px solid ${T.border}`}}>{refDisplay}</span>}
            <span style={{fontSize:10,fontWeight:700,color:sc,background:`${sc}20`,padding:"2px 8px",borderRadius:20,textTransform:"uppercase"}}>{STATUT_L[t.statut]||t.statut}</span>
            <span style={{fontSize:10,fontWeight:700,color:pc,background:`${pc}18`,padding:"2px 8px",borderRadius:20}}>{t.priorite}</span>
            <span style={{fontSize:10,color:T.muted}}>{SOURCE_IC[t.source]||"📋"} {t.source}</span>
          </div>
          <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:5}}>{t.objet}</div>
          <div style={{fontSize:12,color:T.muted,display:"flex",gap:12,flexWrap:"wrap"}}>
            {t.client_nom&&<span>👤 {t.client_nom}</span>}
            {t.ville&&<span>📍 {t.ville}</span>}
            <span>📅 {new Date(t.created_at).toLocaleDateString("fr-FR",{day:"2-digit",month:"2-digit",year:"numeric"})}</span>
          </div>
          {t.description&&<div style={{fontSize:11,color:T.muted,marginTop:5,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{t.description.slice(0,100)}</div>}
        </div>
        {/* Actions rapides */}
        <div style={{display:"flex",flexDirection:"column",gap:6,flexShrink:0,justifyContent:"center"}}>
          {["ouvert","open"].includes(t.statut)&&(
            <button onClick={e=>{e.stopPropagation();changeStatut(t.id,"en_cours");}}
              style={{padding:"5px 10px",borderRadius:8,background:`${T.warning}20`,border:`1px solid ${T.warning}40`,color:T.warning,fontSize:11,fontWeight:700,cursor:"pointer",whiteSpace:"nowrap"}}>
              ▶ Prendre en charge
            </button>
          )}
          {["en_cours","in-progress"].includes(t.statut)&&(
            <button onClick={e=>{e.stopPropagation();changeStatut(t.id,"resolu");}}
              style={{padding:"5px 10px",borderRadius:8,background:`${T.success}20`,border:`1px solid ${T.success}40`,color:T.success,fontSize:11,fontWeight:700,cursor:"pointer",whiteSpace:"nowrap"}}>
              ✅ Résoudre
            </button>
          )}
        </div>
      </div>
    );
  };

  // Stats SAV
  const nbPrev = tickets.filter(t=>(t.type_sav||"curatif")==="preventif").length;
  const nbCur  = tickets.filter(t=>(t.type_sav||"curatif")==="curatif").length;
  const nbOpen = tickets.filter(t=>["ouvert","open"].includes(t.statut)).length;
  const nbEnCours = tickets.filter(t=>["en_cours","in-progress"].includes(t.statut)).length;
  const topSubTypes = Object.entries(tickets.reduce((acc,t)=>{const k=t.sous_type||"Non classé";acc[k]=(acc[k]||0)+1;return acc;},{})).sort((a,b)=>b[1]-a[1]).slice(0,5);

  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      {/* Header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <div style={{fontSize:25,fontWeight:800,color:T.text,letterSpacing:"-0.7px"}}>🎫 SAV & Tickets</div>
          <div style={{fontSize:13,color:T.muted,marginTop:4}}>{filtered.length} / {tickets.length} ticket(s)</div>
        </div>
        <button onClick={onNew}
          style={{padding:"10px 20px",borderRadius:13,background:`linear-gradient(135deg,${T.danger},#b91c1c)`,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer"}}>
          ＋ Nouveau ticket
        </button>
      </div>

      {/* Filtres statut */}
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        {[["all","Tous",counts.all,"#5b6ef8"],["ouvert","🔴 Ouverts",counts.ouvert,"#ef4444"],["en_cours","🟡 En cours",counts.en_cours,"#f5a623"],["resolu","✅ Résolus",counts.resolu,"#22d3a0"]].map(([k,l,n,col])=>(
          <button key={k} onClick={()=>setStatut(k)}
            style={{padding:"7px 14px",borderRadius:20,border:`1.5px solid ${statut===k?col:T.border}`,background:statut===k?`${col}18`:"transparent",color:statut===k?col:T.muted,fontSize:12,fontWeight:statut===k?700:500,cursor:"pointer",display:"flex",alignItems:"center",gap:6}}>
            {l}<span style={{fontSize:10,background:statut===k?col:"#aaa",color:"#fff",borderRadius:20,padding:"1px 6px",fontWeight:700}}>{n}</span>
          </button>
        ))}
      </div>

      {/* Filtres priorité */}
      <div style={{display:"flex",gap:6,flexWrap:"wrap",alignItems:"center"}}>
        <span style={{fontSize:12,color:T.muted}}>Priorité :</span>
        {[["all","Toutes"],["critique","🔴 Critique"],["haute","🟡 Haute"],["normale","🔵 Normale"],["basse","🟢 Basse"]].map(([k,l])=>(
          <button key={k} onClick={()=>setPriorite(k)}
            style={{padding:"5px 11px",borderRadius:20,border:`1px solid ${priorite===k?T.accent:T.border}`,background:priorite===k?T.accentDim:"transparent",color:priorite===k?T.accent:T.muted,fontSize:11,fontWeight:priorite===k?700:400,cursor:"pointer"}}>
            {l}
          </button>
        ))}
      </div>

      {/* Barre outils */}
      <div style={{display:"flex",gap:10,flexWrap:"wrap",alignItems:"center"}}>
        <div style={{display:"flex",alignItems:"center",gap:8,background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:"8px 13px",flex:1,minWidth:200}}>
          <span style={{color:T.muted}}>🔍</span>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Objet, description, ville..."
            style={{background:"none",border:"none",outline:"none",color:T.text,fontSize:13,flex:1}}/>
          {search&&<button onClick={()=>setSearch("")} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:16}}>✕</button>}
        </div>
        <select value={triPar} onChange={e=>{setTriPar(e.target.value);setGrouped(e.target.value==="date");}}
          style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:9,padding:"8px 12px",color:T.text,fontSize:13,outline:"none",cursor:"pointer"}}>
          <option value="date">📅 Date</option>
          <option value="priorite">🔺 Priorité</option>
          <option value="statut">● Statut</option>
          <option value="ville">📍 Ville</option>
        </select>
        <button onClick={()=>setOrdre(o=>o==="asc"?"desc":"asc")}
          style={{padding:"8px 12px",borderRadius:9,background:T.card,border:`1px solid ${T.border}`,color:T.muted,fontSize:16,cursor:"pointer",fontWeight:700}}>
          {ordre==="asc"?"↑":"↓"}
        </button>
        {triPar==="date"&&(
          <button onClick={()=>setGrouped(g=>!g)}
            style={{padding:"8px 12px",borderRadius:9,background:grouped?T.accentDim:T.card,border:`1px solid ${grouped?T.accent:T.border}`,color:grouped?T.accent:T.muted,fontSize:12,fontWeight:grouped?700:500,cursor:"pointer",whiteSpace:"nowrap"}}>
            📂 {grouped?"Sections actives":"Grouper"}
          </button>
        )}
      </div>

      {/* Liste */}
      {filtered.length===0 ? (
        <div style={{textAlign:"center",padding:60,color:T.muted}}>
          <div style={{fontSize:36,marginBottom:10}}>🎫</div>
          <div style={{fontSize:14,fontWeight:700,color:T.text}}>Aucun ticket trouvé</div>
        </div>
      ) : groupedData ? (
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          {groupedData.map(({label,items})=>{
            const sc = SEC_C[label]||T.muted;
            const isCollapsed = collapsed[label];
            return(
              <div key={label}>
                <div onClick={()=>toggleSection(label)}
                  style={{display:"flex",alignItems:"center",gap:10,marginBottom:8,cursor:"pointer",userSelect:"none"}}>
                  <div style={{height:1,width:12,background:`${sc}60`,flexShrink:0}}/>
                  <span style={{fontSize:13,fontWeight:700,color:sc,whiteSpace:"nowrap"}}>{label}</span>
                  <span style={{fontSize:11,background:`${sc}20`,color:sc,padding:"2px 9px",borderRadius:20,fontWeight:700}}>{items.length}</span>
                  <div style={{flex:1,height:1,background:`${sc}30`}}/>
                  <span style={{color:T.muted,fontSize:12,transform:isCollapsed?"rotate(-90deg)":"none",transition:"transform 0.2s"}}>▼</span>
                </div>
                {!isCollapsed&&(
                  <div style={{display:"flex",flexDirection:"column",gap:7}}>
                    {items.map(t=><TicketCard key={t.id} t={t}/>)}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div style={{display:"flex",flexDirection:"column",gap:7}}>
          {filtered.map(t=><TicketCard key={t.id} t={t}/>)}
        </div>
      )}

      {/* Modale clôture + email */}
      {pendingClose&&(
        <div style={{position:"fixed",inset:0,background:"rgba(8,12,30,0.35)",backdropFilter:"blur(4px)",zIndex:1100,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,boxShadow:"0 16px 48px rgba(0,0,0,0.16)",width:500,display:"flex",flexDirection:"column"}}>
            <div style={{padding:"18px 22px 14px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0}}>
              <div>
                <div style={{fontSize:17,fontWeight:800,color:T.text}}>{pendingClose.newStatut==="resolu"?"✅ Marquer comme résolu":"🔒 Fermer le ticket"}</div>
                <div style={{fontSize:12,color:T.muted,marginTop:3}}>{pendingClose.ticket.objet}</div>
              </div>
              <button onClick={()=>setPendingClose(null)} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:20}}>✕</button>
            </div>
            <div style={{padding:"16px 22px",display:"flex",flexDirection:"column",gap:14}}>
              {/* Toggle envoi email */}
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 14px",background:T.bg,borderRadius:10,border:`1px solid ${T.border}`}}>
                <div>
                  <div style={{fontSize:13,fontWeight:700,color:T.text}}>📧 Envoyer un email au client</div>
                  <div style={{fontSize:11,color:T.muted,marginTop:2}}>Informer le client que son ticket est {pendingClose.newStatut==="resolu"?"résolu":"fermé"}</div>
                </div>
                <button onClick={()=>setCloseSendMail(v=>!v)}
                  style={{width:42,height:24,borderRadius:12,border:"none",cursor:"pointer",position:"relative",background:closeSendMail?"#10b981":"#cbd5e1",transition:"background 0.2s",flexShrink:0}}>
                  <div style={{position:"absolute",top:2,left:closeSendMail?18:2,width:20,height:20,borderRadius:"50%",background:"#fff",transition:"left 0.2s",boxShadow:"0 1px 4px rgba(0,0,0,0.15)"}}/>
                </button>
              </div>
              {closeSendMail&&(
                <>
                  <div style={{display:"flex",flexDirection:"column",gap:5}}>
                    <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px"}}>Adresse email</label>
                    <input value={closeEmail} onChange={e=>setCloseEmail(e.target.value)} placeholder="email@client.fr" type="email"
                      style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"9px 12px",color:T.text,fontSize:13,outline:"none"}}/>
                    {!closeEmail&&<div style={{fontSize:11,color:T.warning}}>⚠ Aucun email client renseigné dans la fiche client</div>}
                  </div>
                  <div style={{display:"flex",flexDirection:"column",gap:5}}>
                    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                      <label style={{fontSize:11,fontWeight:700,color:T.muted,textTransform:"uppercase",letterSpacing:"0.5px"}}>Message</label>
                      <button onClick={genererSuggestionsIA} disabled={aiSuggLoading||!closeMsg.trim()}
                        style={{padding:"4px 10px",borderRadius:8,background:`${T.accent}18`,border:`1px solid ${T.accent}40`,color:T.accent,fontSize:11,fontWeight:700,cursor:aiSuggLoading?"default":"pointer",opacity:aiSuggLoading?0.6:1}}>
                        {aiSuggLoading?"⏳ Génération...":"✨ Suggestions IA"}
                      </button>
                    </div>
                    <textarea value={closeMsg} onChange={e=>setCloseMsg(e.target.value)} rows={6}
                      style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:9,padding:"9px 12px",color:T.text,fontSize:12,outline:"none",resize:"vertical",lineHeight:1.6,fontFamily:"inherit"}}/>
                    {aiSuggError&&<div style={{fontSize:11,color:T.warning}}>{aiSuggError}</div>}
                    {aiSuggestions&&aiSuggestions.length>0&&(
                      <div style={{display:"flex",flexDirection:"column",gap:6,marginTop:2}}>
                        {aiSuggestions.map((s,idx)=>(
                          <button key={idx} onClick={()=>{setCloseMsg(s);setAiSuggestions(null);}}
                            style={{textAlign:"left",padding:"8px 10px",borderRadius:9,background:T.bg,border:`1px solid ${T.border}`,color:T.text,fontSize:11.5,lineHeight:1.5,cursor:"pointer",whiteSpace:"pre-wrap"}}>
                            {s}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
            <div style={{padding:"12px 22px 18px",display:"flex",gap:10}}>
              <button onClick={()=>confirmClose(false)}
                disabled={closeSaving}
                style={{flex:1,padding:"10px",borderRadius:10,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,fontSize:13,fontWeight:600,cursor:"pointer",opacity:closeSaving?0.6:1}}>
                {closeSaving?"...":"Clôturer sans email"}
              </button>
              <button onClick={()=>confirmClose()}
                disabled={closeSaving||(closeSendMail&&!closeEmail)}
                style={{flex:2,padding:"10px",borderRadius:10,border:"none",background:closeSendMail&&closeEmail?"linear-gradient(135deg,#10b981,#059669)":"linear-gradient(135deg,#64748b,#475569)",color:"#fff",fontSize:13,fontWeight:700,cursor:(closeSaving||(closeSendMail&&!closeEmail))?"not-allowed":"pointer",opacity:closeSaving?0.7:1}}>
                {closeSaving?"Traitement...":(closeSendMail&&closeEmail?"✅ Clôturer et envoyer l'email":"✅ Clôturer")}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Détail ticket modal */}
      {selTicket&&(
        <div style={{position:"fixed",inset:0,background:"rgba(8,12,30,0.22)",backdropFilter:"blur(4px)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,boxShadow:"0 12px 40px rgba(0,0,0,0.12),0 2px 8px rgba(0,0,0,0.06)",width:560,maxHeight:"85vh",display:"flex",flexDirection:"column"}}>
            <div style={{padding:"18px 22px 14px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexShrink:0}}>
              <div>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:5}}>
                  {selTicket.reference?.startsWith('SAV-202')&&<span style={{fontSize:11,fontFamily:"monospace",color:T.muted,background:T.bg,padding:"2px 8px",borderRadius:20,border:`1px solid ${T.border}`}}>{selTicket.reference}</span>}
                  <span style={{fontSize:11,fontWeight:700,color:STATUT_C[selTicket.statut]||T.muted,background:`${STATUT_C[selTicket.statut]||T.muted}20`,padding:"2px 9px",borderRadius:20}}>{STATUT_L[selTicket.statut]||selTicket.statut}</span>
                  <span style={{fontSize:11,fontWeight:700,color:PRIO_C[selTicket.priorite]||T.muted,background:`${PRIO_C[selTicket.priorite]||T.muted}18`,padding:"2px 9px",borderRadius:20}}>{selTicket.priorite}</span>
                </div>
                <div style={{fontSize:17,fontWeight:800,color:T.text}}>{selTicket.objet}</div>
              </div>
              <button onClick={()=>setSelTicket(null)} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:22}}>✕</button>
            </div>
            <div style={{flex:1,overflowY:"auto",padding:"16px 22px",display:"flex",flexDirection:"column",gap:12}}>
              {[["📍 Ville",selTicket.ville||"—"],["👤 Client",selTicket.client_nom||"—"],["📅 Date",new Date(selTicket.created_at).toLocaleDateString("fr-FR",{weekday:"long",day:"numeric",month:"long",year:"numeric"})],["📡 Source",SOURCE_IC[selTicket.source]+" "+selTicket.source]].map(([l,v])=>(
                <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"9px 12px",background:T.bg,borderRadius:9,border:`1px solid ${T.border}`}}>
                  <span style={{fontSize:12,color:T.muted}}>{l}</span>
                  <span style={{fontSize:13,fontWeight:600,color:T.text}}>{v}</span>
                </div>
              ))}
              {selTicket.description&&(
                <div style={{background:T.bg,borderRadius:9,border:`1px solid ${T.border}`,padding:"12px 14px"}}>
                  <div style={{fontSize:11,fontWeight:700,color:T.muted,marginBottom:7,textTransform:"uppercase",letterSpacing:"0.5px"}}>Description</div>
                  <div style={{fontSize:13,color:T.text,lineHeight:1.7}}>{selTicket.description}</div>
                </div>
              )}
              {/* Actions */}
              <div style={{display:"flex",gap:10}}>
                {["ouvert","open"].includes(selTicket.statut)&&(
                  <button onClick={()=>changeStatut(selTicket.id,"en_cours")}
                    style={{flex:1,padding:"11px",borderRadius:12,background:`${T.warning}20`,border:`1px solid ${T.warning}40`,color:T.warning,fontSize:13,fontWeight:700,cursor:"pointer"}}>
                    ▶ Prendre en charge
                  </button>
                )}
                {["en_cours","in-progress"].includes(selTicket.statut)&&(
                  <button onClick={()=>changeStatut(selTicket.id,"resolu")}
                    style={{flex:1,padding:"11px",borderRadius:12,background:`${T.success}20`,border:`1px solid ${T.success}40`,color:T.success,fontSize:13,fontWeight:700,cursor:"pointer"}}>
                    ✅ Marquer résolu
                  </button>
                )}
                {["resolu","resolved"].includes(selTicket.statut)&&(
                  <button onClick={()=>changeStatut(selTicket.id,"ferme")}
                    style={{flex:1,padding:"11px",borderRadius:12,background:`${T.muted}20`,border:`1px solid ${T.muted}40`,color:T.muted,fontSize:13,fontWeight:700,cursor:"pointer"}}>
                    🔒 Fermer le ticket
                  </button>
                )}
                {selTicket.ville&&(
                  <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(selTicket.ville+', France')}`}
                    target="_blank" rel="noreferrer"
                    style={{padding:"11px 16px",borderRadius:12,background:"#4285f420",border:"1px solid #4285f440",color:"#4285f4",fontSize:13,fontWeight:700,textDecoration:"none"}}>
                    📍 Maps
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
